export type UserProfile = {
  AccessTokenExpiresAt: string;
  Username: string;
  ApplicationId: string;
  DistrictId?: string;
  SchoolId?: string;
  DistrictName?: string;
  SchoolName?: string;
  OrganizationId?: string;
  BuildingId?: string;
  Role: Array<UserRole>;
  Operations: Array<UserOperation>;
};

export enum UserRole {
  VALIDATION_PORTAL_ADMIN = 'VALIDATION_PORTAL_ADMIN',
  VALIDATION_PORTAL_STATE_USER = 'VALIDATION_PORTAL_STATE_USER',

  VALIDATION_PORTAL_DISTRICT_JOB_RUN_USER = 'VALIDATION_PORTAL_DISTRICT_JOB_RUN_USER',
  VALIDATION_PORTAL_DISTRICT_JOB_READ_USER = 'VALIDATION_PORTAL_DISTRICT_JOB_READ_USER',
  VALIDATION_PORTAL_DISTRICT_DATA_CERTIFIER = 'VALIDATION_PORTAL_DISTRICT_DATA_CERTIFIER',

  VALIDATION_PORTAL_SCHOOL_JOB_RUN_USER = 'VALIDATION_PORTAL_SCHOOL_JOB_RUN_USER',
  VALIDATION_PORTAL_SCHOOL_JOB_READ_USER = 'VALIDATION_PORTAL_SCHOOL_JOB_READ_USER',
  VALIDATION_PORTAL_SCHOOL_DATA_CERTIFIER = 'VALIDATION_PORTAL_SCHOOL_DATA_CERTIFIER',
  
  SECRET_KEY_MASTER='SECRET_KEY_MASTER'
}

export type UserOperation = (typeof UserOperations)[keyof typeof UserOperations];

export const UserOperations = {
  VARIABLE_CREATE: 'VARIABLE_CREATE',
  VARIABLE_EDIT: 'VARIABLE_EDIT',
  VARIABLE_DELETE: 'VARIABLE_DELETE',
  RULE_CREATE: 'RULE_CREATE',
  RULE_EDIT: 'RULE_EDIT',
  RULE_DELETE: 'RULE_DELETE',
  GROUP_CREATE: 'GROUP_CREATE',
  GROUP_EDIT: 'GROUP_EDIT',
  GROUP_DELETE: 'GROUP_DELETE',
  JOB_CREATE: 'JOB_CREATE',
  JOB_EDIT: 'JOB_EDIT',
  JOB_DELETE: 'JOB_DELETE',
  JOB_RUN: 'JOB_RUN',
  CERTIFY_DATA: 'CERTIFY_DATA',
  CAN_VIEW_JOB_FOR_ANY_DISTRICT_OR_SCHOOL: 'CAN_VIEW_JOB_FOR_ANY_DISTRICT_OR_SCHOOL',
  CAN_RUN_JOB_FOR_ANY_DISTRICT_OR_SCHOOL: 'CAN_RUN_JOB_FOR_ANY_DISTRICT_OR_SCHOOL',
  CAN_VIEW_CERTIFICATIONS_FOR_ANY_DISTRICT_OR_SCHOOL: 'CAN_VIEW_CERTIFICATIONS_FOR_ANY_DISTRICT_OR_SCHOOL',
  CAN_VIEW_JOB_FOR_ANY_SCHOOL_IN_ASSIGNED_DISTRICT: 'CAN_VIEW_JOB_FOR_ANY_SCHOOL_IN_ASSIGNED_DISTRICT',
  CAN_RUN_JOB_FOR_ANY_SCHOOL_IN_ASSIGNED_DISTRICT: 'CAN_RUN_JOB_FOR_ANY_SCHOOL_IN_ASSIGNED_DISTRICT',
  CAN_VIEW_CERTIFICATIONS_FOR_ANY_SCHOOL_IN_ASSIGNED_DISTRICT: 'CAN_VIEW_CERTIFICATIONS_FOR_ANY_SCHOOL_IN_ASSIGNED_DISTRICT',
} as const;
